<template>
  <div v-if="showBanner && !isCrawler && !showRenameNotice" class="cookie-consent" role="dialog" aria-modal="true" :aria-label="m.cookies.bannerTitle">
    <div class="cookie-consent__panel">
      <div class="cookie-consent__head">
        <h2 class="cookie-consent__title">{{ m.cookies.bannerTitle }}</h2>
        <div class="cookie-consent__controls">
          <AccessibilityToggle banner />
          <LangSwitch banner :aria-label="m.nav.languageSelection" />
        </div>
      </div>
      <p class="cookie-consent__text">{{ m.cookies.bannerDescription }}</p>

      <div class="cookie-consent__actions">
        <button type="button" class="cookie-consent__btn cookie-consent__btn--ghost" @click="openNotice">
          {{ m.footer.cookieNotice }}
        </button>
        <button type="button" class="cookie-consent__btn cookie-consent__btn--primary" @click="acceptAll">
          {{ m.cookies.acceptAll }}
        </button>
        <button type="button" class="cookie-consent__btn cookie-consent__btn--reject" @click="rejectAll">
          {{ m.cookies.rejectAll }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { messages: m } = useI18n()
const { showBanner, isCrawler, acceptAll, rejectAll } = useCookieConsent()
const { openNotice } = useCookieNotice()
const { showRenameNotice } = useRenameNotice()
</script>